import { useContext } from 'react';

import type { FeatureFlagContextType } from '@/contexts/feature-flag/feature-flag-context';
import { FeatureFlagContext } from '@/contexts/feature-flag/feature-flag-context';

export function useFeatureFlags(): FeatureFlagContextType {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagProvider');
  }
  return context;
}
